import { render, staticRenderFns } from "./Ic_tabsPayment.vue?vue&type=template&id=661c7484&"
import script from "./Ic_tabsPayment.vue?vue&type=script&lang=js&"
export * from "./Ic_tabsPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports